/* eslint no-underscore-dangle: ["error", { "allow": ["_root", "_tail"] }] */
// need this eslint rule since griddle now produces dangling vars...

import React from 'react';
import PropTypes from 'prop-types';
import { simplApiUrlPure } from '../../../api/simplApi';
import { fromJS } from 'immutable';
import classes from './PersonImporter.scss';
import { Link } from 'react-router';

class PersonImporter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      persons: fromJS({}),
      importing: false,
      total: 0,
      imported: 0,
      importDone: false,
    };
    this.timeout = null;
    this.selectedPersons = [];
    this.importInterval = null;
  }

  componentDidMount() {
    this.fetchPersons();
  }

  componentWillUnmount() {
    clearInterval(this.timeout);
  }

  fetchPersons() {
    if (this.state.persons.size === 0) {
      const apiCall = this.props.fetchPersonGoogleImport();
      apiCall.then(json => {
        if (json.status === 'OK') {
          this.setState({ persons: fromJS(json.contacts) });
          clearInterval(this.timeout);
        }
      });
    }
  }

  switchAll = (checked = true) => {
    let state = this.state.persons;

    state.forEach(person => {
      state = state.setIn([person.get('id'), 'selected'], checked);
    });

    this.setState({ persons: state });
  };

  startImport = () => {
    this.setState({ importing: true, importDone: false });

    const persons = [];

    this.state.persons.forEach(person => {
      if (person.get('selected') === true) {
        const personObject = {
          name: person.get('name'),
          id: null,
          address: {},
          company_ids: [],
          contactDetails: [],
          birthday: null,
          avatar_id: '',
          meta: {
            notes: '',
          },
          files: [],
          tasks: [],
        };

        person.get('phoneNumbers').forEach(number => {
          personObject.contactDetails.push({
            value: number,
            type: 'mobile',
            note: '',
          });
        });

        person.get('emails').forEach(email => {
          personObject.contactDetails.push({
            value: email,
            type: 'email',
            note: '',
          });
        });

        persons.push(personObject);
      }
    });

    this.setState({ total: persons.length });
    this.selectedPersons = persons;

    this.importInterval = setInterval(() => this.importPerson(), 200);
  };

  importPerson = () => {
    if (this.state.imported < this.state.total) {
      const person = this.selectedPersons[this.state.imported];
      this.props.savePerson(person, false);
      this.setState({ imported: this.state.imported + 1, importDone: true });
    }
  };

  renderPerson = person => {
    return (
      <tr key={`person_${person.get('id')}`}>
        <td>
          <input
            type="checkbox"
            checked={this.state.persons.getIn([person.get('id'), 'selected'])}
            onChange={() => {
              this.setState({
                persons: this.state.persons.setIn(
                  [person.get('id'), 'selected'],
                  !this.state.persons.getIn([person.get('id'), 'selected']),
                ),
              });
            }}
          />
        </td>
        <td>{person.get('name')}</td>
        <td>{person.get('emails').join(', ')}</td>
        <td>{person.get('phoneNumbers').join(', ')}</td>
      </tr>
    );
  };

  renderTable = () => {
    const persons = [];

    this.state.persons.forEach(person => {
      persons.push(this.renderPerson(person));
    });

    return (
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Aktion</th>
            <th>Name</th>
            <th>Emails</th>
            <th>Telefonnummern</th>
          </tr>
        </thead>
        <tbody>{persons}</tbody>
      </table>
    );
  };

  renderGlassPane = () => {
    if (
      this.state.total > 0 &&
      this.state.imported === this.state.total &&
      this.state.importDone === true
    ) {
      clearInterval(this.importInterval);
      return (
        <div className={classes.glasspane}>
          Import erfolgreich abgeschlossen!
          <br />
          <Link to={'/person'}>Zur Kontaktuebersicht</Link>
        </div>
      );
    }

    if (!this.state.importing) {
      return null;
    }

    return (
      <div className={classes.glasspane}>
        Importiere Kontakte...
        <br />
        {this.state.imported}/{this.state.total}
      </div>
    );
  };

  render() {
    const token = localStorage.getItem('token');

    this.timeout = setInterval(() => this.fetchPersons(), 5000);

    return (
      <div className="wrapper">
        <h2 className="gutter">Importieren von Kontakten</h2>
        <div className="gutter">
          <p>
            Sie haben jetzt die Möglichkeit Kontakte von Google zu importieren.
            Dies erfolgt in 4 einfachen Schritten:
          </p>
          <ul>
            <li>
              <a
                href={`${simplApiUrlPure(`oauth/google/${token}`)}`}
                target="_blank"
              >
                Google Account mit SiMPL verknüpfen
              </a>
            </li>
            <li>Kontakte werden hier automatisch geladen</li>
            <li>Auswählen von Kontakten welche Sie importieren möchten</li>
            <li>Import Starten</li>
          </ul>
          <button className="button" onClick={() => this.switchAll(true)}>
            Alle Auswählen
          </button>{' '}
          <button className="button" onClick={() => this.switchAll(false)}>
            Alle Abwählen
          </button>{' '}
          <button
            className="button button-primary"
            onClick={() => this.startImport()}
          >
            Import Starten
          </button>
          <br />
          <br />
        </div>
        <table>{this.renderTable()}</table>
        {this.renderGlassPane()}
      </div>
    );
  }
}
PersonImporter.propTypes = {
  fetchPersonGoogleImport: PropTypes.func.isRequired,
  savePerson: PropTypes.func.isRequired,
};
export default PersonImporter;



// WEBPACK FOOTER //
// ./src/routes/PersonImporter/components/PersonImporter.js